<template>
  <div>
    <material-button
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#modalMenuSetSchedule"
      id="show-modal-menuset-schedule"
    ></material-button>
    <div
      class="modal fade"
      id="modalMenuSetSchedule"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-width">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ 'Add Schedule' +  (pageTitle ? (' - ' + pageTitle) : '') }}
            </h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div class="mt-3">
              <!-- Period Type: stack vertically on mobile, inline on sm+ -->
              <div class="s-menuset d-flex flex-column flex-sm-row align-items-sm-center">
                <div class="me-sm-3 mb-2 mb-sm-0">Period Type</div>
                <div class="flex-grow-1">
                  <Multiselect
                    v-model="periodTypeSelect"
                    :options="periodType"
                    placeholder="Select menu"
                    :canClear="false"
                  />
                </div>
              </div>

              <!-- Calendar: horizontally scrollable on small screens -->
              <div class="mt-5">
                <h5>Select opening and closing times</h5>
                <div class="calendar-scroll-wrapper">
                  <DayPilotCalendar id="dp" :config="config" ref="calendar" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="mt-3 mt-sm-5 d-flex justify-content-center justify-content-sm-end w-100">
              <material-button
                @click="addSchedule"
                class="mx-3 btn btn-sm btn-background"
                >Save</material-button
              >
              <material-button
                class="mx-3 btn btn-sm btn-background"
                data-bs-dismiss="modal"
                aria-label="Close"
                >Cancel</material-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import $ from "jquery";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Multiselect from "@vueform/multiselect";
import ScheduleService from "../services/product/schedule.service";
import { DayPilot, DayPilotCalendar } from "@daypilot/daypilot-lite-vue";
import moment from "moment";

export default {
  name: "schedule",
  components: {
    MaterialButton,
    MaterialLoading,
    DayPilotCalendar,
    Multiselect,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    setIdSelect: {
      type: Number,
      default: 0,
      required: false,
    },
    categoryIdSelect: {
      type: Number,
      default: 0,
      required: false,
    },
    itemIdSelect: {
      type: Number,
      default: 0,
      required: false,
    },
  },
  computed: {
    calendar() {
      return this.$refs.calendar.control;
    },
  },
  data() {
    return {
      snackbar: null,
      message: "",
      loaderActive: false,
      scheduleList: [],
      scheduleIdsDelete: [],
      fieldRequired: {},
      branches: [],
      branchIdSelect: [],
      periodType: [
        {
          value: 1,
          label: "Open Period"
        },
        {
          value: 2,
          label: "Open All Week"
        },
        {
          value: 3,
          label: "Close All Week"
        }
      ],
      periodTypeSelect: 2,
      config: {
        viewType: "Week",
        headerDateFormat: "ddd",
        heightSpec: "Full",
        startDate: DayPilot.Date.today(),
        timeRangeSelectedHandling: "Enabled",
        onTimeRangeSelected: async (args) => {
          const dp = args.control;
          dp.clearSelection();
          let range =
            "From: " +
            this.formatDate(args.start) +
            " - " +
            "To: " +
            this.formatDate(args.end);

          dp.events.add({
            start: args.start,
            end: args.end,
            id: DayPilot.guid(),
            text: range,
            backColor: "#44bd32",
            borderColor: "#38761d",
            type: "create",
            day: moment(args.start, "YYYY-MM-DDTHH:mm:ss").format("dddd"),
          });

          this.scheduleList = dp.events.list;
        },
        eventDeleteHandling: "Update",
        onEventDeleted: (args) => {
          this.scheduleIdsDelete.push(args.e.id());
        },
        eventMoveHandling: "Disabled",
        onEventResized: (args) => {
          const schedule = this.scheduleList.find((e) => e.id === args.e.id());
          if (schedule) {
            let range =
              "From: " +
              this.formatDate(args.e.start()) +
              " - " +
              "To: " +
              this.formatDate(args.e.end());
            schedule.text = range;
            schedule.start = args.e.start();
            schedule.end = args.e.end();
            schedule.type = "update";
          }
          this.loadEvents();
        },
      },
      pageTitle: '',
    };
  },
  mounted() {
    this.loadEvents();
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },

    loadEvents() {
      const events = this.scheduleList;
      this.calendar.update({ events });
    },

    getListSchedule() {
      this.showLoader();
      var dataForm = {
        set_id: this.setIdSelect || this.$route.params.id || 0,
        branch_id: 0,
        category_id: this.categoryIdSelect,
        item_id: this.itemIdSelect
      };

      ScheduleService.getListSchedule(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.periodTypeSelect = response.data.data.type;
            this.pageTitle = response.data.data.label;
            var schedules = response.data.data.schedules;
            var schedulesTemp = [];

            schedules.forEach((schedule) => {
              let range =
                "From: " +
                this.formatDate(schedule.time_from) +
                " - " +
                "To: " +
                this.formatDate(schedule.time_to);

              schedulesTemp.push({
                id: schedule.id,
                start: moment(schedule.time_from).format(
                  "YYYY-MM-DDTHH:mm:ss"
                ),
                end: moment(schedule.time_to).format("YYYY-MM-DDTHH:mm:ss"),
                text: range,
                backColor: "#44bd32",
                borderColor: "#38761d",
                type: "update",
              });
            });

            this.config.startDate = schedules[0]
              ? moment(schedules[0].time_from).format("YYYY-MM-DDTHH:mm:ss")
              : DayPilot.Date.today();
            this.scheduleList = schedulesTemp;
            this.loadEvents();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    addSchedule() {
      this.showLoader();
      var dataForm = {
        set_id: this.setIdSelect || this.$route.params.id || 0,
        branch_id: 0,
        category_id: this.categoryIdSelect,
        item_id: this.itemIdSelect,
        type: this.periodTypeSelect,
        start_date: DayPilot.Date.today(),
        schedule_ids_delete: this.scheduleIdsDelete,
        schedules: this.scheduleList,
      };

      ScheduleService.addSchedule(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.clearData();
            this.$emit("reload-schedule", "Add Schedule Success");
            $(".btn-close-modal").click();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    clearData() {
      this.scheduleIdsDelete = [];
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
  watch: {
    keyReload() {
      this.scheduleList = [];
      this.scheduleIdsDelete = [];
      this.pageTitle = "";
      this.getListSchedule();
      this.loadEvents();
    },
  },
};
</script>

<style scoped>
.modal-content {
  max-height: 80vh;
  min-height: 80vh;
  padding-bottom: 25px;
}

.modal-body {
  max-height: 100%;
  overflow-y: auto;
}

.modal-width {
  min-width: 60%;
}

.s-menuset > div:first-child {
  min-width: 100px;
}

.s-menuset .multiselect {
  margin: 0 !important;
  max-width: 500px !important;
}

/* ── Responsive overrides ── */

/* Tablet / iPad */
@media (max-width: 1024px) {
  .modal-width {
    min-width: 90%;
  }
}

/* Mobile */
@media (max-width: 767px) {
  .modal-dialog {
    margin: 0.5rem auto;
    max-width: 96%;
  }

  .modal-content {
    max-height: 92vh;
    min-height: unset;
  }

  .modal-body {
    padding: 12px;
  }

  /* Calendar: allow horizontal scroll on narrow screens */
  .calendar-scroll-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .modal-footer {
    padding: 10px 12px;
  }
}
</style>